var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageDashboardResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 255,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "image_DashboardResults_svg__c",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "image_DashboardResults_svg__a",
    d: "M0 .282h260.208V14.32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153 69h172v116H153V69z",
    stroke: "#7D32FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4,9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.654 150.567l-225.439-.645.421-145.005c.008-2.723 2.238-4.924 4.98-4.917l215.508.616c2.742.008 4.958 2.222 4.95 4.945l-.42 145.006z",
    fill: "#B3B6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.944 8.418h205.662a2 2 0 012 2v9.786H26.944v-9.786a2 2 0 012-2z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.287 23.007l209.15.599-.342 118.194a3.407 3.407 0 01-2.116 3.148 3.413 3.413 0 01-1.306.258l-202.327-.58a3.416 3.416 0 01-3.402-3.425l.343-118.194z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.758 149.725)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "image_DashboardResults_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image_DashboardResults_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.562 14.32L6.608 13.606C2.948 13.595-.01 10.603 0 6.925.01 3.244 2.986.271 6.647.281L253.6.997c3.66.01 6.619 3.002 6.608 6.68-.01 3.68-2.986 6.654-6.646 6.644",
    fill: "#E8E8F7",
    mask: "url(#image_DashboardResults_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.129 158.204l-24.886-.065c-.962-.003-1.74-.723-1.737-1.609.003-.886.785-1.602 1.747-1.599l24.886.066c.961.002 1.738.723 1.736 1.608-.003.886-.785 1.602-1.746 1.6",
    fill: "#B3B6DE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D32FF",
    d: "M26.944 20.204h31.997v125.434H26.944z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F7",
    d: "M58.099 20.204h178.507v125.434H58.099z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4267B2",
    x: 72.014,
    y: 32.832,
    width: 45.469,
    height: 14.311,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 72.014,
    y: 56.403,
    width: 45.469,
    height: 21.046,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C13584",
    x: 126,
    y: 33,
    width: 45.469,
    height: 14.311,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 125.903,
    y: 56.403,
    width: 45.469,
    height: 21.046,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4284F4",
    x: 179,
    y: 33,
    width: 45.469,
    height: 14.311,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 178.95,
    y: 56.403,
    width: 45.469,
    height: 21.046,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M72.014 86.709h152.404v48.827H72.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.014 86.71H223.42a1 1 0 011 1v4.05H72.014v-4.05a1 1 0 011-1z",
    fill: "#7D32FF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 97.653,
    width: 43.785,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 103.169,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 137.691,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 160.426,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 187.37,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 210.946,
    y: 60.612,
    width: 3.368,
    height: 6.735,
    rx: 1.684
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 119.541,
    width: 37.049,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C19AEC",
    d: "M188.212 26.939h37.049v2.526h-37.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E5CA1",
    d: "M209.262 12.628h15.156v2.526h-15.156z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 30.306,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 37.883,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 45.459,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 53.036,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 60.612,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 77.449,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7E5CA1",
    x: 33.282,
    y: 69.872,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 85.026,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C5AFDD",
    x: 33.282,
    y: 92.602,
    width: 15.156,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 108.597,
    width: 37.049,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 103.546,
    width: 43.785,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 125.434,
    width: 43.785,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C19AEC",
    x: 80.434,
    y: 114.49,
    width: 43.785,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 97.653,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 76.224,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 133.481,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 184.844,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 98.959,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 156.216,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 207.578,
    y: 70.714,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 119.541,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 108.597,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 103.546,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 125.434,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 135.165,
    y: 114.49,
    width: 10.946,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 97.653,
    width: 47.153,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 119.541,
    width: 31.997,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M72.014 26.939h31.997v2.526H72.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.287 36.057v1.309h-.018l-.396.002h-.306c-.084 0-.168 0-.252.011a.934.934 0 00-.168.038.52.52 0 00-.2.116.495.495 0 00-.13.23c-.027.093-.036.19-.036.286v.975h1.45c.002.023-.181 1.444-.189 1.466h-1.234l-.025.001a.037.037 0 00-.001.004v.002l-.001.001V44.252l-.001.002-.001.001-.001.002a92.53 92.53 0 01-1.51-.002V40.49h-1.264L76 40.484 76 40.475v-1.44l.001-.006.001-.002.004-.003h1.247l.014-.002v-.026-1.036c0-.065.004-.13.007-.196.004-.102.017-.203.035-.303.03-.163.076-.32.144-.47.101-.226.244-.422.435-.58.261-.218.566-.335.899-.385.043-.007.087-.011.13-.015.046-.005.091-.009.136-.01.17-.002.341-.001.511.006l.172.008.217.011.055.004.151.014.128.013",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M72.014 51.352h31.997v2.526H72.014zM72.014 81.658h31.997v2.526H72.014z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 108.597,
    width: 54.731,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 103.546,
    width: 31.997,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 125.434,
    width: 47.153,
    height: 2.526,
    rx: 1.263
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 160.426,
    y: 114.49,
    width: 54.731,
    height: 2.526,
    rx: 1.263
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEAEA",
    fill: "#F7F7F7",
    d: "M.783 0h126v152h-126z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.783 46)",
    fill: "#A7A7A7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.222,
    width: 37.4,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.111,
    width: 37.4,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.556,
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 27.778,
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.667,
    width: 44,
    height: 2.222,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.783 106)",
    fill: "#A7A7A7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.222,
    width: 37.4,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.111,
    width: 37.4,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.556,
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 27.778,
    width: 44,
    height: 2.222,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.667,
    width: 44,
    height: 2.222,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.783 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "image_DashboardResults_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image_DashboardResults_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#7D32FF",
    xlinkHref: "#image_DashboardResults_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9582",
    mask: "url(#image_DashboardResults_svg__d)",
    d: "M20.057-3.343v23.4l24.514 5.572-2.228-26.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE436",
    mask: "url(#image_DashboardResults_svg__d)",
    d: "M20.057 20.057L47.914 15.6l3.343 30.086-44.571 5.571-3.343-8.914z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#B184FF",
    x: 15.783,
    y: 29,
    width: 31,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B184FF",
    x: 69.783,
    y: 88,
    width: 31,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B184FF",
    x: 15.783,
    y: 37,
    width: 41,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B184FF",
    x: 69.783,
    y: 96,
    width: 41,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9582",
    d: "M15 121h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D32FF",
    d: "M27 104h7v32h-7zM40 99h7v37h-7zM52 93h7v43h-7z"
  })))));
}

export default __webpack_public_path__ + "static/image_DashboardResults.5993b859.svg";
export { SvgImageDashboardResults as ReactComponent };